// extracted by mini-css-extract-plugin
export default {"imgWrapper":"LogoInvoice_imgWrapper__mQOYk"};